(() => {
  const script = document.currentScript;
  const slideLabel = script?.dataset.slideLabel || 'Go to slide __number__';

  const labelSliderControls = (root = document) => {
    root.querySelectorAll('[hdt-slider-dots]').forEach((dots) => {
      const sliderId = dots.getAttribute('aria-controls');
      dots.querySelectorAll('button.hdt-slider__dot').forEach((dot, index) => {
        if (!dot.hasAttribute('aria-label')) {
          dot.setAttribute('aria-label', slideLabel.replace('__number__', String(index + 1)));
        }
        if (sliderId && !dot.hasAttribute('aria-controls')) {
          dot.setAttribute('aria-controls', sliderId);
        }
        if (dot.classList.contains('hdt-slider__dot--selected')) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    });
  };

  const scheduleLabels = () => {
    window.requestAnimationFrame(() => labelSliderControls());
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleLabels, { once: true });
  } else {
    scheduleLabels();
  }

  window.addEventListener('load', scheduleLabels, { once: true });
  document.addEventListener('shopify:section:load', scheduleLabels);
  window.setTimeout(scheduleLabels, 1000);
})();
